import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { onboardingService } from '../services/onboarding.service';

/**
 * Garde d'onboarding (cf. saas/08). Enveloppe les routes owner SAUF /onboarding.
 * Si l'owner n'a pas terminé (coloc + chambre + photo), on le redirige vers le
 * wizard. État déduit de l'API (pas de flag). En cas d'erreur réseau, on laisse
 * passer (ne pas bloquer le back-office sur une panne).
 */
const OnboardingGate: React.FC = () => {
  const [state, setState] = useState<'loading' | 'done' | 'redirect'>('loading');

  useEffect(() => {
    let cancelled = false;
    // Wizard explicitement passé : on n'appelle même pas l'API, l'utilisateur
    // a déjà tranché. Sans ce court-circuit, le bouton « Passer » renverrait
    // au wizard en boucle.
    if (onboardingService.isSkipped()) {
      setState('done');
      return;
    }
    onboardingService
      .getState()
      .then((s) => {
        if (!cancelled) setState(s.done ? 'done' : 'redirect');
      })
      .catch(() => {
        if (!cancelled) setState('done'); // fail-open
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'loading') {
    return (
      <div style={{ maxWidth: 420, margin: '80px auto', textAlign: 'center', padding: 24 }}>
        <p>Chargement…</p>
      </div>
    );
  }
  if (state === 'redirect') {
    return <Navigate to="/onboarding" replace />;
  }
  return <Outlet />;
};

export default OnboardingGate;
